<span *ngIf="displayFamillesGemrcn" (dblclick)="openProduitOnFamnut()" class="cursor">
  <ng-container *ngFor="let fnp of famillesNutritionnellesProduits ;trackBy: menuPlanningSvc.trackByFn">
    <yo-famille-gemrcn [familleNutri]="menuCompoSvc.getFamilleNutri(fnp)"  ></yo-famille-gemrcn>
  </ng-container>
</span>

